<template>
  <div>
    <vue-good-table :columns="columns_balance" :rows="data.result" :lineNumbers="false"
				:search-options="{ enabled: true, placeholder: 'Поиск...' }" :paginationOptions="{
					enabled: true,
					nextLabel: '',
					prevLabel: '',
					rowsPerPageLabel: 'Строк',
					ofLabel: 'из',
					allLabel: 'Все',
				}">
				<div slot="emptystate">
					<div class="text-center">
						Нет данных
					</div>
				</div>
				<template slot="table-row" slot-scope="props">
					<span v-if="props.column.field == 'image'">
						<img onerror="javascript:this.src='/images/avatar/user.png'"
							v-bind:src="`/images/avatar/` + props.row.user.avatar" class="user-avatar" width="40"
							height="40" />
					</span>
          <span v-else-if="props.column.field == 'name'">
						{{ props.row.user.name }}
					</span>
					<span v-else>
						{{ props.formattedRow[props.column.field] }}
					</span>
				</template>
			</vue-good-table>

      <h4 class="mt-3">Итог за этот месяц: {{ data.sum }}</h4>
      <h4 class="mt-3">Потрачено: {{ data.payouts }}</h4>
      <h4 class="mt-3">Получено: {{ data.payins }}</h4>
      <h4 class="mt-3">Итог: {{ data.payins  - data.payouts }}</h4>
  </div>
</template>

<script>
import HTTP from "../http";
import { show_error } from "../message";




export default {
  name: 'Balance',

  data() {
    return {
      data:{},
				columns_balance: [{
					label: '',
					field: 'image',
					width: '50px',
					tdClass: 'text-center hide-993',
					thClass: 'text-center hide-993'
				}, {
					label: 'Имя',
					field: 'name',
          width: '60%',
					thClass: 'align-middle text-nowrap',
					tdClass: 'align-middle text-nowrap'
				},
				{
					label: 'S',
					field: 'sum',
          width: '15%',
          type: "number",
					thClass: 'align-middle text-nowrap ',
					tdClass: 'align-middle text-nowrap '
				},
				{
					label: 'Дата',
					field: 'created_at',
					width: '15%',
					thClass: 'align-middle text-center text-nowrap',
					tdClass: 'align-middle text-center text-nowrap'
				}],
    }
  },
  created() {
		this.fetchData();
	},
  methods: {
		fetchData() {
			this.loading = true;
			this.$insProgress.start();
			HTTP()
				.get("admin/balance")
				.then((resp) => {
					console.log('resp', resp)
          this.data = resp.data
				})
				.catch((error) => {
					show_error(this.$notify, this.$refs.form, error.response.data)
				})
				.finally(() => {
					this.loading = false;
					this.$insProgress.finish();
				});
		},
	},
}
</script>
